import getDateFormat from './getDateFormat'
import { format } from 'date-fns'

export const setTimeZone = (date: number) => {
  const offSet = new Date().getTimezoneOffset() / 60
  return offSet > 0 ? new Date(date).setHours(new Date(date).getHours() + offSet) : new Date(date).setHours(new Date(date).getHours() - offSet)
}

const formatDate = (date: number, selectedFormat?: string) => {
  const dateFormat = selectedFormat || getDateFormat('date')
  return format(setTimeZone(date), dateFormat)
}

export default formatDate
